<template>
  <Card tag="form" class="residential-template-mutate-presentation" @submit.prevent="$emit('submit')">
    <template #default>
      <div class="residential-template-mutate-presentation__input">
        <CustomFields
          data-field="fields"
          :value="value"
          @input="e => $emit('updateValue', e)"
          :schema="customFieldSchemas"
          :data="data"
          :validator="validator"
          :placement="['residential-template:presentation']"
        >
          <!-- render slots -->
          <template v-for="item in fields.slots" v-slot:[item.slotKey]>
            <FieldRenderer :item="item" :value="value" @input="e => $emit('updateValue', { ...e, slot: true })" />
          </template>
        </CustomFields>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Card'
import { i18n } from '@/i18n'
import CustomFields from '@kvass/custom-fields'
import FieldRenderer from '@/components/Residential/StepsFields/FieldRenderer.vue'

const meta = {
  order: 2,
  id: 'presentation',
  label: i18n.tc('presentation'),
  icon: ['fal', 'image'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    data: Object,
    customFieldSchemas: { type: Array, default: () => [] },
    fields: { type: Object, default: () => ({}) },
  },

  components: {
    Card,
    CustomFields,
    FieldRenderer,
  },
}
</script>

<style lang="scss">
.residential-template-mutate-presentation {
  $cols: 6;

  &__input {
    display: grid;
    grid-template-columns: repeat($cols, 1fr);
    grid-gap: $form-gap;
  }

  [data-field='fields'] {
    grid-column-end: span $cols;
  }
}
</style>
